import { render, staticRenderFns } from "./MemberAuthorization.vue?vue&type=template&id=7d94b768&scoped=true&"
import script from "./MemberAuthorization.vue?vue&type=script&lang=js&"
export * from "./MemberAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d94b768",
  null
  
)

export default component.exports